var $6f80afde0270dda7$exports = {};
$6f80afde0270dda7$exports = {
  "alpha": "Alfa",
  "black": "svart",
  "blue": "Bl\xE5tt",
  "blue purple": "bl\xE5lila",
  "brightness": "Ljusstyrka",
  "brown": "brun",
  "brown yellow": "brungul",
  "colorName": function colorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue);
  },
  "cyan": "cyan",
  "cyan blue": "cyanbl\xE5",
  "dark": "m\xF6rk",
  "gray": "gr\xE5",
  "grayish": "gr\xE5aktig",
  "green": "Gr\xF6nt",
  "green cyan": "gr\xF6n cyan",
  "hue": "Nyans",
  "light": "ljus",
  "lightness": "Ljushet",
  "magenta": "magenta",
  "magenta pink": "magentarosa",
  "orange": "orange",
  "orange yellow": "orangegul",
  "pale": "blek",
  "pink": "rosa",
  "pink red": "rosar\xF6d",
  "purple": "lila",
  "purple magenta": "lila magenta",
  "red": "R\xF6tt",
  "red orange": "r\xF6dorange",
  "saturation": "M\xE4ttnad",
  "transparentColorName": function transparentColorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue, ", ").concat(args.percentTransparent, " genomskinlig");
  },
  "very dark": "mycket m\xF6rk",
  "very light": "mycket ljus",
  "vibrant": "livfull",
  "white": "vit",
  "yellow": "gul",
  "yellow green": "gulgr\xF6n"
};
export { $6f80afde0270dda7$exports as default };